/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Segment, Header, Divider, List, Button,
  Dimmer, Modal, Icon, Progress, Loader,
  Popup, Checkbox
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";

import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

class SegmentDevices extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      // Verificar os dados do mestre
      checkMaster: false,
      // Devices List
      inSegmentDevices: [],
      otherDevices: [],
      // Search status
      searchStatus: false,
      // Dimmers
      isSearchDimmerActive: false,
      isSendDimmerActive: false,
      isDevicesListDimmerActive: false,
      // Modals
      isSearchModalOpen: false,
      // Start time
      startTime: 0,
      percent: 0,
    };
  }

  toggleCheckMaster = () => {
    this.setState({
      checkMaster: !this.state.checkMaster
    });
  }

  getCheckMaster = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "verificarMestreDoSegmento", { mode: "cors" })
      .then(UtilsInstance.checkStatus)
      .then(res => res.json())
      .then(data => this.setState({ checkMaster: data.checkMaster }))
      .catch(() => {
        this.setState({ checkMaster: false }, () => {
          alert(Strings.GET_CHECK_MASTER_ERROR);
        });
      });
  }

  // ----------------- Modals -----------------
  openSearchConfirmModal = () => this.setState({ isSearchModalOpen: true });
  closeSearchConfirmModal = () => this.setState({ isSearchModalOpen: false });

  // ----------------- Search Phases -----------------
  startSearch = () => {
    this.setState({
      isSearchModalOpen: false,     // Esconda o Modal
      isSearchDimmerActive: true,   // Mostre o loading,
      startTime: new Date()
    }, async () => {

      // Faça um POST pra dizer ao backend que ele deverá iniciar a busca
      let hasSearchStarted = await fetch(Constants.REQUEST_IP_ADDRESS + "iniciarbuscaEscravosSegmento_POST", {
        method: "POST",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        body: { "start": true }
      })
        .then(UtilsInstance.checkStatus)
        .then(() => { return true; })
        .catch(() => { return false; });

      console.log("hasSearchStarted: ", hasSearchStarted);

      // Se iniciar a busca deu certo, começe a esperar pelo resultado
      if (hasSearchStarted) {
        this.handleDeviceSearchCycles();
      }
      // Se não foi possível iniciar a busca, avise o usuário
      else {
        this.setState({
          isSearchDimmerActive: false,
          startTime: 0,
          percent: 0
        }, () => {
          alert(Strings.START_SEARCH_ERROR_MESSAGE);
        });
      }
    });
  }

  handleDeviceSearchCycles = () => {
    let intervalID = -1;
    intervalID = setInterval(this.handleAlterConfigurationStatus, 5000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleAlterConfigurationStatus = async () => {
    let currentStatus = await fetch(Constants.REQUEST_IP_ADDRESS + "statusBuscarEscravosSegmento", { mode: "cors" })
      .then(UtilsInstance.checkStatus)
      .then(res => res.json())
      .then(data => data)
      .catch(() => "");

    console.log("statusBuscarEscravosSegmento: ", currentStatus);

    const currentTime = new Date();
    const secondsPassed = (currentTime - this.state.startTime) / 1000;
    let percentage = Math.floor((secondsPassed * 100) / 300);
    if (percentage >= 99) { percentage = 99; }

    //console.log(percentage);
    this.setState({ percent: percentage });

    // Se o status salvo da busca for falso e o status retornado for true quer dizer que a busca teve inicio
    if (this.state.searchStatus === false && currentStatus === true) {
      this.setState({ searchStatus: currentStatus });
    }
    // Se o status salvo da busca for true e o status retornado for false quer dizer que a busca teve fim
    else if (this.state.searchStatus === true && currentStatus === false) {
      this.setState({
        searchStatus: currentStatus,
        isSearchDimmerActive: false,
        // Resete os valores de start time e a porcentagem
        startTime: 0,
        percent: 0
      }, () => {
        clearInterval(this.state.intervalID);
        alert(Strings.SEARCH_FINISH_SUCCESS);
        this.getDevicesList();
      });
    }
  }

  getDevicesList = () => {
    this.setState({ isDevicesListDimmerActive: true }, () => {
      fetch(Constants.REQUEST_IP_ADDRESS + "dadosEscravosSegmento", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => {
          let inSegmentDevices = this.processDevicesList(data.escravosDesteSegmento, Constants.IN_SEGMENT);
          let possiblyInSegmentDevices = this.processDevicesList(data.possiveisEscravosDesteSegmento, Constants.POSSIBLY_IN_SEGMENT);
          let possiblyInOtherSegmentDevices = this.processDevicesList(data.possiveisOutrosSegmentos, Constants.NOT_IN_SEGMENT);
          let otherDevices = possiblyInSegmentDevices.concat(possiblyInOtherSegmentDevices);

          // Filtre todos os dispositivos que já estiver na lista de pertencentes ao segmento
          otherDevices = otherDevices.filter(item1 =>
            !inSegmentDevices.some(item2 => item2.address === item1.address)
          );

          inSegmentDevices = inSegmentDevices.sort(UtilsInstance.sortBy("address", false, parseInt));
          otherDevices = otherDevices.sort(UtilsInstance.sortBy("address", false, parseInt));

          this.setState({
            inSegmentDevices: inSegmentDevices,
            otherDevices: otherDevices,
            isDevicesListDimmerActive: false
          });

        })
        .catch(() => {
          this.setState({ isDevicesListDimmerActive: false }, () => {
            alert(Strings.GET_DEVICES_LIST_ERROR);
          });
        });
    });
  }

  processDevicesList = (devices, type) => {
    let devicesList = [];

    if (type === Constants.IN_SEGMENT) {
      for (let i = 0; i < devices.length; i++) {
        devicesList.push({
          "address": devices[i],
          "type": Constants.IN_SEGMENT,
          "currentList": Constants.IN_SEGMENT_LIST
        });
      }
    }
    else if (type === Constants.POSSIBLY_IN_SEGMENT) {
      for (let i = 0; i < devices.length; i++) {
        devicesList.push({
          "address": devices[i],
          "type": Constants.POSSIBLY_IN_SEGMENT,
          "currentList": Constants.OTHER_LIST
        });
      }
    }
    else if (type === Constants.NOT_IN_SEGMENT) {
      for (let i = 0; i < devices.length; i++) {
        devicesList.push({
          "address": devices[i],
          "type": Constants.NOT_IN_SEGMENT,
          "currentList": Constants.OTHER_LIST
        });
      }
    }

    return devicesList;
  }

  getDeviceListItem = (device) => {
    if (device.currentList === Constants.IN_SEGMENT_LIST) {
      return (
        <List.Item key={device.address}>
          <List.Content floated='right' style={{ marginTop: "4px" }}>
            <Button
              size="tiny"
              circular
              color="teal"
              icon="chevron left"
              onClick={() => { this.changeList(device, Constants.IN_SEGMENT_LIST); }} />
          </List.Content>
          <List.Content style={listContentStyle}>
            <List.Header style={{ marginBottom: "2px" }}>{Strings.ADDRESS_DP} {device.address}</List.Header>
            <List.Description>
              {this.getDeviceListDescription(device.type)}
            </List.Description>
          </List.Content>
        </List.Item>
      );
    }
    else {
      return (
        <List.Item key={device.address}>
          <List.Content floated='right' style={{ marginTop: "4px" }}>
            <Button
              size="tiny"
              circular
              color="teal"
              icon="chevron right"
              onClick={() => { this.changeList(device, Constants.OTHER_LIST); }} />
          </List.Content>
          <List.Content style={listContentStyle}>
            <List.Header style={{ marginBottom: "2px" }}>{Strings.ADDRESS_DP} {device.address}</List.Header>
            <List.Description>
              {this.getDeviceListDescription(device.type)}
            </List.Description>
          </List.Content>
        </List.Item>
      );
    }
  }

  getDeviceListDescription = (deviceType) => {
    if (deviceType === Constants.IN_SEGMENT) {
      return Strings.IN_SEGMENT;
    }
    else if (deviceType === Constants.POSSIBLY_IN_SEGMENT) {
      return Strings.POSSIBLY_IN_SEGMENT;
    }
  }

  changeList = (device, currentList) => {
    let inSegmentDevices = JSON.parse(JSON.stringify(this.state.inSegmentDevices));
    let otherDevices = JSON.parse(JSON.stringify(this.state.otherDevices));
    let deviceCopy = JSON.parse(JSON.stringify(device));

    if (currentList === Constants.IN_SEGMENT_LIST) {
      inSegmentDevices = inSegmentDevices.filter(dev => dev.address !== deviceCopy.address);
      deviceCopy.currentList = Constants.OTHER_LIST;
      otherDevices.push(deviceCopy);
      otherDevices = otherDevices.sort(UtilsInstance.sortBy("address", false, parseInt));
    }
    else {
      otherDevices = otherDevices.filter(dev => dev.address !== deviceCopy.address);
      deviceCopy.currentList = Constants.IN_SEGMENT_LIST;
      inSegmentDevices.push(deviceCopy);
      inSegmentDevices = inSegmentDevices.sort(UtilsInstance.sortBy("address", false, parseInt));
    }

    this.setState({
      inSegmentDevices: inSegmentDevices,
      otherDevices: otherDevices
    });
  }

  sendSegmentDevices = () => {
    this.setState({ isSendDimmerActive: true }, async () => {
      const segmentDevicesToPost = JSON.stringify({
        escravosDesteSegmento: this.state.inSegmentDevices.map(obj => obj.address)
      });

      console.log("segmentDevicesToPost: ", segmentDevicesToPost);

      let segmentDevicesPOSTResult = await fetch(Constants.REQUEST_IP_ADDRESS + "escravosDesteSegmento_POST", {
        method: "POST",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        body: segmentDevicesToPost
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          return { "success": true, text: "" };
        })
        .catch((error) => {
          return { "success": false, text: error };
        });


      let checkMasterPOSTResult = await fetch(Constants.REQUEST_IP_ADDRESS + "verificarMestreDoSegmento_POST", {
        method: "POST",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        body: JSON.stringify({ checkMaster: this.state.checkMaster })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          return { "success": true, text: "" };
        })
        .catch((error) => {
          return { "success": false, text: error };
        });

      if (segmentDevicesPOSTResult.success && checkMasterPOSTResult.success) {
        this.setState({ isSendDimmerActive: false }, () => {
          alert(Strings.SEND_SEGMENT_DEVICES_INFO_SUCCESS);
          this.getDevicesList();
          this.getCheckMaster();
        });
      }
      else {
        this.setState({ isSendDimmerActive: false }, () => {
          alert(Strings.SEND_SEGMENT_DEVICES_INFO_ERROR
            + "\n" + Strings.REASON_DP + segmentDevicesPOSTResult.text
            + "\n" + Strings.REASON_DP + checkMasterPOSTResult
          );
          this.getDevicesList();
          this.getCheckMaster();
        });
      }
    });
  }

  moveAllToRight = () => {
    let inSegmentDevices = JSON.parse(JSON.stringify(this.state.inSegmentDevices));
    let otherDevices = JSON.parse(JSON.stringify(this.state.otherDevices));

    for (let i = 0; i < otherDevices.length; i++) {
      otherDevices[i].currentList = Constants.IN_SEGMENT_LIST;
      inSegmentDevices.push(otherDevices[i]);
    }

    inSegmentDevices = inSegmentDevices.sort(UtilsInstance.sortBy("address", false, parseInt));
    otherDevices = [];

    console.log(inSegmentDevices);

    this.setState({
      inSegmentDevices: inSegmentDevices,
      otherDevices: otherDevices
    });
  }

  moveAllToLeft = () => {
    let inSegmentDevices = JSON.parse(JSON.stringify(this.state.inSegmentDevices));
    let otherDevices = JSON.parse(JSON.stringify(this.state.otherDevices));

    for (let i = 0; i < inSegmentDevices.length; i++) {
      inSegmentDevices[i].currentList = Constants.OTHER_LIST;
      otherDevices.push(inSegmentDevices[i]);
    }

    otherDevices = otherDevices.sort(UtilsInstance.sortBy("address", false, parseInt));
    inSegmentDevices = [];

    console.log(otherDevices);

    this.setState({
      inSegmentDevices: inSegmentDevices,
      otherDevices: otherDevices
    });
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.getDevicesList();
    this.getCheckMaster();
  }

  render() {
    const isSearchDimmerActive = this.state.isSearchDimmerActive;
    const isSendDimmerActive = this.state.isSendDimmerActive;
    const isDevicesListDimmerActive = this.state.isDevicesListDimmerActive;

    const inSegmentDevices = this.state.inSegmentDevices.map(device => (
      this.getDeviceListItem(device)
    ));

    const otherDevices = this.state.otherDevices.map(device => (
      this.getDeviceListItem(device)
    ));

    return (
      <div style={{ marginLeft: "3vw" }} >
        <Grid columns={2} doubling>
          <Grid.Row>

            <Grid.Column textAlign="center" width={3} style={{ paddingLeft: "0" }}>

              <Segment>

                <Divider horizontal fitted style={{ marginBottom: "1vh" }}>
                  {Strings.SEARCH}
                  <Popup position='bottom left' hoverable pinned wide="very"
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>{Strings.SEARCH_POPUP_1}</p>
                      <p>{Strings.SEARCH_POPUP_2}</p>
                      <p>
                        {Strings.SEARCH_POPUP_3_1}
                        <b>{Strings.SEARCH_POPUP_3_2}</b>
                        {Strings.SEARCH_POPUP_3_3}
                        <b>{Strings.SEARCH_POPUP_3_4}</b>
                      </p>
                      <p>
                        {Strings.SEARCH_POPUP_4_1}
                        <b>{Strings.SEARCH_POPUP_4_2}</b>
                        {Strings.SEARCH_POPUP_4_3}
                        <b>{Strings.SEARCH_POPUP_4_4}</b>
                        {Strings.SEARCH_POPUP_4_5}
                      </p>
                      <p>{Strings.SEARCH_POPUP_5}</p>
                      <p>
                        <b>{Strings.SEARCH_POPUP_6_1}</b>
                        {Strings.SEARCH_POPUP_6_2}
                      </p>
                    </Popup.Content>
                  </Popup>
                </Divider>

                <Button
                  color="teal"
                  content={Strings.SEARCH}
                  fluid
                  onClick={this.openSearchConfirmModal} />
                <br />

                <Divider horizontal fitted style={{ marginBottom: "1vh" }}>
                  {Strings.SAVE}
                  <Popup position='bottom left' hoverable pinned wide="very"
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>
                        {Strings.SAVE_POPUP_1_1}
                        <b>{Strings.SAVE_POPUP_1_2}</b>
                        {Strings.SAVE_POPUP_1_3}
                      </p>
                      <p>
                        {Strings.SAVE_POPUP_2_1}
                        <b>{Strings.SAVE_POPUP_2_2}</b>
                        {Strings.SAVE_POPUP_2_3}
                        <b>{Strings.SAVE_POPUP_2_4}</b>
                      </p>
                      <Divider horizontal>{Strings.EXPLANATION}</Divider>
                      <p>{Strings.SAVE_POPUP_3}</p>
                      <p>{Strings.SAVE_POPUP_4}</p>
                    </Popup.Content>
                  </Popup>
                  <br />
                </Divider>

                <Checkbox
                  toggle
                  label={Strings.CHECK_MASTER}
                  onClick={this.toggleCheckMaster}
                  checked={this.state.checkMaster}
                />

                <Button
                  color="teal"
                  content={Strings.SAVE}
                  fluid
                  onClick={this.sendSegmentDevices} />

              </Segment>

            </Grid.Column>

            <Grid.Column width={13} style={{ paddingRight: "0" }}>

              <Grid doubling>

                <Grid.Row columns={2}>
                  <Grid.Column>
                    <Segment style={leftSegmentStyle}>

                      <Header as='h2' textAlign="center" color="teal">
                        {Strings.AVAILABLE_DEVICES}
                        <Popup position='bottom center' hoverable pinned wide="very"
                          trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                          <Popup.Content>
                            <p>
                              {Strings.AVAILABLE_DEVICES_POPUP_1_1}
                              <b>{Strings.AVAILABLE_DEVICES_POPUP_1_2}</b>
                            </p>
                            <p>{Strings.AVAILABLE_DEVICES_POPUP_2} <b>{Strings.AVAILABLE_DEVICES_POPUP_2_1}</b></p>
                            <p>
                              {Strings.AVAILABLE_DEVICES_POPUP_3_1}
                              <Icon size="large" color="teal" name="chevron circle right" />
                              {Strings.AVAILABLE_DEVICES_POPUP_3_2}
                              <b>{Strings.AVAILABLE_DEVICES_POPUP_3_3}</b>
                              {Strings.AVAILABLE_DEVICES_POPUP_3_4}
                              <b>{Strings.AVAILABLE_DEVICES_POPUP_3_5}</b>
                              {Strings.AVAILABLE_DEVICES_POPUP_3_6}
                              <b>{Strings.AVAILABLE_DEVICES_POPUP_3_7}</b>
                              {Strings.AVAILABLE_DEVICES_POPUP_3_8}
                            </p>
                            <p>
                              <b>{Strings.AVAILABLE_DEVICES_POPUP_4_1}</b>
                              {Strings.AVAILABLE_DEVICES_POPUP_4_2}
                            </p>
                          </Popup.Content>
                        </Popup>
                      </Header>

                      <Divider clearing />

                      <Segment id="problems-list" style={listSegmentStyle} basic>
                        <List size="medium" animated divided style={listStyle}>
                          {otherDevices}
                        </List>
                      </Segment>

                      <Dimmer active={isDevicesListDimmerActive}>
                        <Loader indeterminate>
                          {Strings.LOADING_DEVICES}
                        </Loader>
                      </Dimmer>
                    </Segment>

                    <Button
                      fluid
                      icon='chevron right'
                      color="teal"
                      content={Strings.MOVE_ALL}
                      labelPosition='right'
                      onClick={this.moveAllToRight} />

                  </Grid.Column>

                  <Grid.Column>
                    <Segment style={rightSegmentStyle}>
                      <Header
                        as='h2'
                        textAlign="center"
                        color="teal">
                        {Strings.SELECTED_DEVICES}
                        <Popup position='bottom right' hoverable pinned wide="very"
                          trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                          <Popup.Content>
                            <p>
                              {Strings.SELECTED_DEVICES_POPUP_1_1}
                              <b>{Strings.SELECTED_DEVICES_POPUP_1_2}</b>
                            </p>
                            <p>
                              {Strings.SELECTED_DEVICES_POPUP_2_1}
                              <b>{Strings.SELECTED_DEVICES_POPUP_2_2}</b>
                              {Strings.SELECTED_DEVICES_POPUP_2_3}
                              <b>{Strings.SELECTED_DEVICES_POPUP_2_4}</b>
                            </p>
                            <p>
                              <b>{Strings.SELECTED_DEVICES_POPUP_3_1}</b>
                              {Strings.SELECTED_DEVICES_POPUP_3_2}
                            </p>
                          </Popup.Content>
                        </Popup>

                      </Header>
                      <Divider clearing />

                      <Segment id="problems-list" style={listSegmentStyle} basic>
                        <List size="medium" animated divided style={listStyle}>
                          {inSegmentDevices}
                        </List>
                      </Segment>

                      <Dimmer active={isDevicesListDimmerActive}>
                        <Loader indeterminate>
                          {Strings.LOADING_DEVICES}
                        </Loader>
                      </Dimmer>
                    </Segment>

                    <Button
                      fluid
                      icon='chevron left'
                      color="teal"
                      content={Strings.MOVE_ALL}
                      labelPosition='left'
                      onClick={this.moveAllToLeft} />

                  </Grid.Column>
                </Grid.Row>

              </Grid>
            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Modal style={searchModalStyle} centered size="small" open={this.state.isSearchModalOpen}>
          <Header icon="exclamation triangle" content={Strings.CONFIRM_SEARCH_START} />
          <Modal.Content>
            <p>
              {Strings.CONFIRM_SEARCH_START_POPUP_1_1}
              <b>{Strings.CONFIRM_SEARCH_START_POPUP_1_2}</b>
              {Strings.CONFIRM_SEARCH_START_POPUP_1_3}
            </p>
            <p>
              <b>{Strings.CONFIRM_SEARCH_START_POPUP_2_4}</b>{Strings.CONFIRM_SEARCH_START_POPUP_2_1}
              <b>{Strings.CONFIRM_SEARCH_START_POPUP_2_2}</b>
              {Strings.CONFIRM_SEARCH_START_POPUP_2_3}
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.closeSearchConfirmModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.startSearch}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Dimmer page active={isSearchDimmerActive}>
          <Header inverted color="grey">
            <p>{Strings.SEARCHING_DEVICES}</p>
            <p>{Strings.PLEASE_STAY_IN_PAGE}</p>
          </Header>

          <Progress
            active
            color="teal"
            percent={this.state.percent}
            style={{ width: "50vw", marginBottom: "0" }} />

          <Header
            inverted
            color="grey"
            content={`${this.state.percent} %`}
            style={{ width: "50vw", marginBottom: "0" }} />

        </Dimmer>

        <Dimmer page active={isSendDimmerActive}>
          <Loader size="huge" indeterminate>
            {Strings.SENDING_DEVICES_INFO}
          </Loader>
        </Dimmer>

      </div >
    );
  }
}

const listStyle = {
  marginLeft: "24px",
  marginRight: "24px",
  textAlign: "center"
};

const leftSegmentStyle = {
  height: "75vh",
  marginBottom: "0.5vh"
};

const rightSegmentStyle = {
  height: "75vh",
  marginBottom: "0.5vh"
};

const listSegmentStyle = {
  overflowY: "scroll",
  height: "60vh"
};

const listContentStyle = {
  marginTop: "4px",
  marginBottom: "4px"
};

const searchModalStyle = {
  width: "800px",
  height: "245px",
  margin: "20vh auto"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(SegmentDevices);
